import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ErrorService } from '@fund-base/services/error/error.service';
import {
  createSubmission,
  createTask,
  createWorkPlan,
  deleteTask,
  fetchWorkPlans,
  setWorkPlanLoading,
  setWorkPlans,
  updateSubmission,
  updateTask,
  updateWorkPlan,
} from '@fund-base/store/actions/workplan.action';
import { catchError, switchMap } from 'rxjs';
import { UserService } from '@fund-base/services/user/user.service';
import { showToast } from '../actions/ui.actions';
import { ToastType } from '@fund-base/types/ui/ui.types';
import { WorkPlanService } from '@fund-base/services/workplan/workplan.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class PeekingAssistantEffects {
  constructor(private actions$: Actions, private store: Store) {}
}
